var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVolumeMute(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9l4.632-4.343C10.91 3.46 13 4.366 13 6.117v11.767c0 1.75-2.09 2.656-3.368 1.459L5 15H2a2 2 0 01-2-2v-2a2 2 0 012-2h3z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGc+CjxwYXRoIGQ9Ik01IDkuMDAwMDVMOS42MzIxMiA0LjY1NzQ0QzEwLjkwOTQgMy40NTk5NCAxMyA0LjM2NTYzIDEzIDYuMTE2NTFWMTcuODgzNkMxMyAxOS42MzQ1IDEwLjkwOTUgMjAuNTQwMiA5LjYzMjEyIDE5LjM0MjdMNSAxNUgyQzAuODk1NDMgMTUgMCAxNC4xMDQ2IDAgMTNWMTEuMDAwMUMwIDkuODk1NDggMC44OTU0MzEgOS4wMDAwNSAyIDkuMDAwMDVINVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };